import React from 'react';
import ReactDOM from 'react-dom/client';
import ContactIndex from './Components/ContactPages/ContactIndex';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <div>
        <ContactIndex />
    </div>
);

